.root {
    width: 260px;
    padding: 0 16px 16px;
}

.title {
    display: block;
    margin-bottom: 10px;
}

.table {
    border-collapse: collapse;
    td {
        padding-bottom: 5px;
    }
}
